import { render } from "./haircolorDiag.vue?vue&type=template&id=38edd22e"
import script from "./haircolorDiag.vue?vue&type=script&lang=js"
export * from "./haircolorDiag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__